import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import './RadioButton.scss';
import InfoBox from '../InfoBox/InfoBox';
import PlanUtilities from '../../services/PlanService';
import PlanIdUtil from '../../common/PlanIdUtil';
import PlanDetails from '../../common/PlanDetails';
import SubscriptionDiscountService from '../../services/SubscriptionDiscountService';
import Configuration from '../../common/Configuration.json';

/*
//Total to pay now code will add it later
const getPriceText = (price, isZeroFree) => {
  if (isZeroFree) {
    return price > 0 ? `$${price}` : 'FREE';
  }
  return `${price}`;
};

const getTotalToPayContent = (charges, giftWithPurchase) => {
  const totalToPay = getPriceText(charges.total, false);
  if (giftWithPurchase.enabled) {
    totalToPay.splice(1, 0, {
      leftContent: <p className="plan-summary-text">{giftWithPurchase.name}</p>,
      rightContent: <p className="plan-summary-text">{getPriceText(0, true)}</p>
    });
  }
  if (charges.discountApplied) {
    totalToPay.splice(2, 0, {
      leftContent: <p className="plan-summary-text line-item-highlight">Discount</p>,
      rightContent:
        <p className="plan-summary-text line-item-highlight">
          -{getPriceText(charges.discountApplied, true)}
        </p>
    });
  }
  return totalToPay;
};
*/

const getModemSummary = (isContract, modemValue, charges) => {
  if (isContract) {
    return (<div>
      <div><b>FREE</b> {Configuration.modemName}</div>
      <div>(worth ${Configuration.modemPrice})</div>
    </div>);
  } else if (charges.discountApplied > 0) {
    return (
      <div>
        <div><b>SAVE ${charges.discountApplied} off your modem</b></div>
        <div>(pay only ${charges.modemCostLessDiscount} today, usually ${charges.modemCost})</div>
      </div>
    );
  }
  return (
    <div>
      <div>${charges.modemCost} {Configuration.modemName} pay up-front</div>
    </div>
  );
};
const getItems = (
  isFixedTerm, modemValue, connectionPrice, shippingPrice, offer, discount, discountWithSubscription, isByoModemSelected
) => {
  const charges = PlanUtilities.getChargeSummary(isFixedTerm, connectionPrice, shippingPrice, modemValue, discount);
  const items = [
    <div className="plan-info-list-item">
      {SubscriptionDiscountService.hasDiscountWithSubscription(isFixedTerm, discountWithSubscription) &&
      <div>
        {SubscriptionDiscountService.getDescription(isFixedTerm, discountWithSubscription)}
      </div>
      }
    </div>,
    <div className="plan-info-list-item">
      {isFixedTerm &&
      <div>
        <div><b>FREE</b> standard connection</div>
        <div>(worth ${connectionPrice})</div>
      </div>
      }
      {!isFixedTerm &&
      <div>
        <div>${connectionPrice} standard connection fee pay up-front</div>
      </div>
      }
    </div>,
    <div>
      {!isByoModemSelected &&
      <div className="plan-info-list-item">
        {getModemSummary(isFixedTerm, modemValue, charges)}
      </div>
      }
    </div>,
    <div className="plan-info-list-item">
      {isFixedTerm ? 'Early termination fee applies' : 'Cancel connection any time'}
    </div>,
    <div className="plan-info-list-item">Online & phone support</div>,
    <div>{!isByoModemSelected && <div className="plan-info-list-item">${shippingPrice} Modem shipping and handling fee applies</div>}</div>
  ];
  if (offer && offer.enabled) {
    items.splice(2, 0,
      <div className="plan-info-list-item bold">
        FREE {offer.name} (worth ${offer.value})
      </div>
    );
  }
  return items;
};

const HorizontalRadioButton = (props) => {
  const radioProps = omit(
    props,
    'description',
    'modemPrice',
    'connectionPrice',
    'credit',
    'offer',
    'discount',
    'shippingPrice',
    'discountWithSubscription',
    'giftWithPurchase',
    'isByoModemSelected',
    'byoModemDiscountPrice',
    'selectedPlan',
    'withMobileDiscount'
  );
  const isContract = (props.id === 'contract-plan');
  // Code for Total to Pay Now will add it later
  // const charges = PlanUtilities.getChargeSummary(isContract, props.connectionPrice, props.shippingPrice, props.modemPrice, props.discount, props.isByoModemSelected);
  return (
    <div>
      {SubscriptionDiscountService.hasDiscountWithSubscription(isContract, props.discountWithSubscription) &&
      <div className="promo-tag-container">
        {SubscriptionDiscountService.getDescription(isContract, props.discountWithSubscription)}
      </div>
      }
      <InfoBox
        title={props.description}
        infoBoxClass={isContract ? 'info-box' : 'info-box-narrow'}
        listItems={
          getItems(
            isContract,
            props.modemPrice,
            props.connectionPrice,
            props.shippingPrice,
            props.offer,
            props.discount,
            props.discountWithSubscription,
            props.isByoModemSelected
          )
        }
      >
        <input
          type="radio"
          className="radio-input"
          {...radioProps}
        />
        <label
          className={`radio-label autotest-${props.id}`}
          htmlFor={props.id}
        >
          {props.label}
        </label>
        <div className="total-pay-heading">Monthly plan price:</div>
        <div className="total-pay"><span>$</span>{PlanIdUtil.getPlanPrice((props.isByoModemSelected ? (props.selectedPlan.price - props.byoModemDiscountPrice) : props.selectedPlan.price), props.withMobileDiscount ? [Configuration.skinnyMobileCustomerDiscount.amount] : [])}</div>
        <a className="legal-summary" href={PlanDetails.legalOfferSummaryLink} rel="noopener noreferrer" target="_blank">Legal offer summary here</a>
      </InfoBox>
      {props.credit &&
      <div className="section-credit">
        <div className="section-credit-amount">
          ${props.credit}
        </div>
        <div className="section-credit-text">
          <div className="section-credit-text-large">joining credit</div>
          <div className="section-credit-text-small">towards your first</div>
          <div className="section-credit-text-small">month&apos;s bill</div>
        </div>
      </div>
      }
      {props.discount && props.discount.enabled &&
      <div className="discount-maru">
        <div className="section-discount-text">Save</div>
        <div className="section-discount-amount">
          {props.discount.value}
        </div>
      </div>
      }
    </div>
  );
};

HorizontalRadioButton.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  modemPrice: PropTypes.number,
  connectionPrice: PropTypes.number,
  shippingPrice: PropTypes.number,
  credit: PropTypes.number,
  offer: PropTypes.object,
  discount: PropTypes.shape(
    {
      enabled: PropTypes.bool,
      value: PropTypes.number
    }
  ),
  discountWithSubscription: PropTypes.shape(
    {
      enabled: PropTypes.bool
    }
  ),
  isByoModemSelected: PropTypes.bool,
  byoModemDiscountPrice: PropTypes.number,
  selectedPlan: PropTypes.object,
  withMobileDiscount: PropTypes.bool
};


export default HorizontalRadioButton;



/** WEBPACK FOOTER **
 ** ./src/components/RadioButton/HorizontalRadioButton.js
 **/